<template>
    <div class="case_detial no-trans" v-loading="loading">
        <div class="case_detial_box">

            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/case_list">案例库</router-link> > <span aria-current="page">详情</span>
            </div>
            <div class="detial_flex">
                <div class="inof_box" :class="{inof_box_show:is_show}">
                    <div class="info_pay_btns" v-if="is_show">
                        <div class="info_pay_btns_top"></div>
                        <div class="info_pay_btns_bom">
                            <div class="btns_pay" @click="handle_pay">
                                付费查看
                            </div>
                        </div>
                    </div>
                    <div class="info_1">
                        <div class="title_flex">
                            {{ case_detial.title }}
                            
                        </div>
                        <div class="tage_info">
                            <div class="tage_flex">
                                <div class="tege_title">时间：</div>
                                <div class="tege_text">{{ case_detial.created_at }}</div>
                            </div>
                            <div class="borders"></div>
                            <div class="tage_flex">
                                <div class="tege_title">标签：</div>
                                <div class="tege_text"><span>{{ case_detial.cateid_title }}</span></div>
                            </div>
                            <div class="borders"></div>
                            <div class="tage_flex">
                                <div class="tege_title">阅读：</div>
                                <div class="tege_text">{{case_detial.views}}人</div>
                            </div>
                        </div>
                        <div class="const_box">
                            <div class="const_flex">
                                <div class="const_title">案由：</div>
                                <div class="const_text">{{ case_detial.cateid3_title }}</div>
                            </div>
                            <div class="const_flex">
                                <div class="const_title">纠纷发生地：</div>
                                <div class="const_text">{{ case_detial.happen_province }}</div>
                            </div>
                            <div class="const_flex">
                                <div class="const_title">委托人住所地：</div>
                                <div class="const_text">{{ case_detial.province }}</div>
                            </div>
                            <div class="const_flex">
                                <div class="const_title">提出审判异议：</div>
                                <div class="const_text"></div>
                            </div>
                            <div class="const_const">
                                {{ case_detial.trial_obj }}
                            </div>
                            <div class="flie_flex">
                                <div class="flie_img">
                                    <img src="../../../assets/img/index/comments_case/flie_url.png" alt="">
                                    相关材料
                                </div>
                                <div class="flie_list">
                                    <div class="flie_name" v-for="(item,index) in file_list" :key="index" @click="handle_url(item)">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="case_infos" v-if="case_detial.summarize">
                        <div class="case_titles">案例总结</div>
                        <div class="case_texts">
                            {{ case_detial.summarize }}
                        </div>
                    </div>
                    <div class="pl_num_box" v-if="lawyer_comment.length>10&&lawyer_comment.length!=lawyer_comment_index" @click="lawyer_comment_index=lawyer_comment.length">
                        查看全部 {{ lawyer_comment.length }} 个点评
                    </div>
                    <div class="pl_infos" v-for="(item,index) in lawyer_comment" :key="index" v-if="index<lawyer_comment_index" >
                        <div class="pl_user">
                            <div class="user_img">
                                <img src="../../../assets/img/index/comments_case/user_img.png" alt="" v-if="!(item.lawyer||{}).avatar">
                                <img :src="(item.lawyer||{}).avatar" alt="" v-else>
                            </div>
                            <div class="user_info">
                                <div class="user_name">{{ (item.lawyer||{}).name }}资深法律顾问</div>
                                <div class="user_time">发布于 {{ item.created_at }}</div>
                            </div>
                        </div>
                        <div v-for="(items,indexs) in vuex_form_list" :key="indexs" v-if="items.show_num==item.grade">
                            <div class="pl_titles">{{ items.title }}</div>
                            <div class="pl_consts">
                                {{ item[items.form_text] }}

                            </div>
                        </div>
                            
                    </div>
                    <div class="pl_num_box" v-if="lawyer_comment.length>10" @click="lawyer_comment_index=lawyer_comment.length">
                        查看全部 {{ lawyer_comment.length }} 个点评
                    </div>
                    <div class="comment_section">
                        <div class="title_btns">
                            <div class="titles">评论区</div>
                            <div class="btns">
                                <div class="btns1" @click="handle_good">
                                    <img src="@/assets/img/index/comments_case/zan.png" alt="">
                                    赞同 {{case_detial.good_num}}
                                </div>
                                <div class="btns2" @click="handle_bad">
                                    <img src="@/assets/img/index/comments_case/cai.png" alt="">
                                </div>
                                <div class="btns3" @click="handle_open">
                                    <img src="@/assets/img/index/comments_case/pl_num.png" alt="">
                                    评论
                                </div>
                            </div>
                        </div>
                        <div class="comment_list">
                            <div class="items" v-for="(item,index) in pl_list" :key="index">
                                <div class="items_top">
                                    <div class="user_imgs">
                                        <img :src="item.image" alt="" v-if="item.image">
                                        <img src="@/assets/img/index/comments_case/user_img.png" v-else alt="">
                                    </div>
                                    <div class="user_info">
                                        <div class="names">{{ item.user.nickname||"用户昵称" }}</div>
                                        <div class="times">{{ item.created_at }}</div>
                                    </div>
                                    <div class="comment_num">
                                        <div class="num_flex">
                                            <div class="nums" v-for="(items,indexs) in 5" :key="indexs">
                                                <img src="../../../assets/img/index/legal/plx_ac.png" alt="" v-if="indexs<=(item.level-1)">
                                                <img src="../../../assets/img/index/legal/plx_no.png" alt="" v-if="indexs>(item.level-1)">
                                            </div>
                                        </div>
                                        <div class="comment_text">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                                <div class="items_bom" v-if="item.comment">
                                    {{ item.comment }}
                                </div>
                            </div>
                            <div class="comment_num_btns" @click="handle_pl_list" v-if="case_detial.comment_num!=pl_list.length">
                                <span>查看全部 {{ case_detial.comment_num }} 个评论</span>
                            </div>
                             <div class="comment_num_btns2" v-else>
                                <span>没有更多了</span>
                            </div>
                        </div>
                    </div>
                    <div class="comprehensive_reviews" v-if="case_detial.review">
                        <div class="review_title">综合点评</div>
                        <div class="review_text">
                            {{case_detial.review}}
                            
                        </div>
                    </div>
                    <div class="announcement_box">
                        <div class="announcement_title">公告</div>
                        <div class="announcement_text">
                            一、 本裁判文书库公布的裁判文书由相关法院录入和审核，并依据法律与审判公开的原则予以公开。若有关当事人对相关信息内容有异议的，可向公布法院书面申请更正或者下镜。 二、本裁判文书库提供的信息仅供查询人参考，内容以正式文本为准。非法使用裁判文书库信息给他人造成损害的，由非法使用人承担法律责任。 三、本裁判文书库信息查询免费， 严禁任何单位和个，人利用本裁判文书库信息牟取非法利
                        </div>
                    </div>
                </div>
                <div class="">
                    <comments_list_right ref="comments_list_right"></comments_list_right>
                </div>
            </div>
        </div>
        <comments_form_pl ref="comments_form_pl" @pl_end="pl_end"></comments_form_pl>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import comments_list_right from '@/components/comments/comments_list_right.vue'//右边
import comments_form_pl from '@/components/comments/comments_form_pl.vue'//提交评论


export default {
    components: {
        comments_list_right,
        comments_form_pl,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            is_show:false,
            case_detial:{},
            file_list:[],
            lawyer_comment:[],
            lawyer_comment_index:10,
            limit:2,//评论列表
            pl_list:[],
        }
    },
    computed: {
        ...mapState(['vuex_form_list'])
       
    },
    watch: {
        $route: {
            handler(newVal, oldVal) {
                this.get_detial()
                this.get_pl_list()
            },
            immediate: true,
            deep: true
        },
    },
    created() {
      
    },
    methods: {
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_pay(){
            this.$router.push({
                path:'/case_pay',
                query:{
                    id:this.$route.query.id
                }
            })
            
        },
        pl_end(){
            this.get_pl_list()
        },
        handle_pl_list(){
            this.limit=this.case_detial.comment_num
            this.get_pl_list()
        },
        get_pl_list(){
            this.$api("caseCommentList", {
                id:this.$route.query.id,
                limit:this.limit,
			}, "get").then((res) => {
                this.loading = false
                console.log('案例评论列表',res)
                if (res.code == 1) {
                    this.pl_list=res.data.data
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_url(item){
            window.open(item.path)
        },
        handle_open(){
            this.$refs.comments_form_pl.handle_open()
        },
        handle_good(){
            this.$api("caseOp", {
                id:this.$route.query.id,
                op: this.case_detial.is_op==1?'cancel':'good',//bad
			}, "post").then((res) => {
                this.loading = false
                console.log('案例评论列表',res)
                if (res.code == 1) {
                    
                    this.get_detial()
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_bad(){
            this.loading = true
            this.$api("caseOp", {
                id:this.$route.query.id,
                op: this.case_detial.is_op==1?'cancel':'bad',//bad
			}, "post").then((res) => {
                this.loading = false
                console.log('案例评论列表',res)
                if (res.code == 1) {
                   
                    this.get_detial()
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_detial(){
            this.loading = true
            this.$api("caseDetail", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('案例详情',res)
                if (res.code == 1) {
                    this.case_detial=res.data
                    this.lawyer_comment=[]
                    res.data.lawyer_comment.forEach((e)=>{
                        if(e.status==20){

                            this.lawyer_comment.push(e)
                        }
                    })
                    if(res.data.if_pay){
                        if(res.data.has_buy){
                            this.is_show=false
                        }else{

                            this.is_show=true
                        }
                    }else{
                        this.is_show=false
                    }
                    if(res.data.judgment){
                        let judgment=JSON.parse(res.data.judgment)
                        judgment.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }
                    if(res.data.evidence_file){
                        let evidence_file=JSON.parse(res.data.evidence_file)
                        evidence_file.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }
                    if(res.data.record_file){
                        let record_file=JSON.parse(res.data.record_file)
                        record_file.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.case_detial{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .case_detial_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .detial_flex{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            .inof_box{
                width: 1000px;
                .info_1{
                    // width: 1000px;
                    // height: 1429px;
                    padding: 40px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .title_flex{
                        display: flex;
                        align-items: center;
                       
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333; 
                        img{
                            margin-left: 10px;
                            width: 70px;
                            height: 25px;
                        }

                    }
                    .tage_info{
                        display: flex;
                        align-items: center; 
                        padding-top: 16px;

                        .tage_flex{
                            display: flex;
                            align-items: center;
                            .tege_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                            }
                            .tege_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                span{
                                    color: #377CFD;
                                }
                            }
                        }
                        .borders{
                            width: 0;
                            height: 15px;
                            border-left: 1px solid #999999;
                            margin: 0 20px;
                        }
                    }
                    .btns_flex{
                        display: flex;
                        align-items: center;
                        padding-top: 20px;
                        padding-bottom: 24px;
                        border-bottom: 1px solid #D9D9D9;
                        .btns1{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                        .btns2{
                            width: 134px;
                            height: 36px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            margin-left: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                    }
                    .const_box{
                        padding-top: 24px;
                        .const_flex{
                            display: flex;
                            align-items: center;
                            margin-bottom: 16px;
                            .const_title{
                                width: 100px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                            .const_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                        .const_const{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-bottom: 40px;
                            border-bottom: 1px solid  #D9D9D9;
                        }
                        .flie_flex{
                            display: flex;
                            // align-items: center;
                            padding-top: 23px;
                            .flie_img{
                                display: flex;
                                // align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                cursor: pointer;
                                img{
                                    width:16px ;
                                    height: 14px;
                                    margin-right: 10px;
                                }
                            }
                            .flie_name{
                                margin-left: 60px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .case_infos{
                    width: 1000px;
                    // min-height: 490px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 26px;
                    padding: 25px 32px 36px 32px;
                    margin-bottom: 20px;
                    .case_titles{
                     
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333;
                        padding-bottom: 21px;
                    }
                    .case_texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 30px;
                    }
                }
                .pl_num_box{
                    width: 100%;
                    height: 50px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    justify-content: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #8590A6;
                    margin-top: 20px;
                    // margin-bottom: 24px;
                }
                .pl_infos{
                    width: 100%;
                    padding: 40px 40px 23px 40px ;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 25px;
                    .pl_user{
                        display: flex;
                        align-items: center;
                        .user_img{
                            width: 64px;
                            height: 64px;
                            img{
                                width: 64px;
                                height: 64px;
                                border-radius: 50%;
                            }
                        }
                        .user_info{
                            padding-left: 24px;
                            .user_name{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 24px;
                                color: #333333;
                            }
                            .user_time{
                                padding-top: 11px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                            }

                        }
                        
                    }
                    .pl_titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        padding-top: 24px;
                    }
                    .pl_consts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        padding-top: 15px;
                    }
                }
                .comment_section{
                    // width: 1000px;
                    // height: 602px;
                    padding: 23px 30px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 20px;
                    .title_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        .btns{
                            display: flex;
                            align-items: center;
                            .btns1{
                                padding: 8px 23px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: #377CFD;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                                img{
                                    width:14px ;
                                    height: 14px;
                                    margin-right: 8px;
                                }
                            }
                            .btns2{
                                width: 36px;
                                height: 36px;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                margin-left: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;

                                img{
                                    width:14px ;
                                    height: 14px;
                                }
                            }
                            .btns3{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                text-align: center;
                                margin-left: 24px;
                                cursor: pointer;
                                img{
                                    width:13px ;
                                    // height: 12px;
                                    // margin-right: 8px;
                                }

                            }
                        }
                    }
                    .comment_list{
                        padding-top: 24px;
                        .items{
                            width: 940px;
                            // min-height: 220px;
                            background: #FFFFFF;
                            border-radius: 3px 3px 3px 3px;
                            border: 1px solid #D7DEE5;
                            margin-bottom: 17px;
                            padding: 21px 29px 30px 25px;
                            .items_top{
                                display: flex;
                                .user_imgs{
                                    width: 64px;
                                    height: 64px;
                                    img{
                                        width: 64px;
                                        height: 64px;
                                        border-radius: 50%;
                                    }
                                }
                                .user_info{
                                    width: 200px;
                                    padding:  8px 0;
                                    padding-left: 24px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-content: space-between;
                                    .names{
                                        width: 100%;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #666666;

                                    }
                                    .times{
                                        width: 100%;
                                       
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #666666;

                                    }
                                }
                                .comment_num{
                                    .num_flex{
                                        display: flex;
                                        align-items: center;
                                        .nums{
                                            img{
                                                width: 21px;
                                                height: 20px;
                                            }
                                        }
                                    }
                                    .comment_text{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #333333;
                                        padding-top: 20px;
                                    }
                                }
                            }
                            .items_bom{
                                // width: 886px;
                                min-height: 78px;
                                background: #F5F5F5;
                                border-radius: 4px 4px 4px 4px;
                                margin-top: 27px;

                                padding:18px 52px 16px 22px ;
                            
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;

                            }
                        }
                        .comment_num_btns{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            span{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #8590A6;
                                cursor: pointer;
                            }

                        }
                        .comment_num_btns2{
                             display: flex;
                            align-items: center;
                            justify-content: center;
                            span{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #8590A6;
                            }

                        }
                    }
                }
                .comprehensive_reviews{
                    width: 1000px;
                    min-height: 194px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 20px;
                    padding: 13px 52px 10px 28px;
                    .review_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }
                    .review_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 30px;
                    }
                }
                .announcement_box{
                    width: 1000px;
                    min-height: 271px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    padding: 13px 52px 14px 28px;
                    margin-top: 16px;
                    .announcement_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        text-align: center;

                    }
                    .announcement_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 32px;
                    }
                }
            }
            .inof_box_show{
                // width: 100%;
                position: relative;
                height: 1270px;
                overflow: hidden;
                background-color: #FFFFFF;
                .info_pay_btns{
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    .info_pay_btns_top{
                        width: 100%;
                        height: 118px;
                        background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
                        border-radius: 0px 0px 0px 0px;
                    }
                    .info_pay_btns_bom{
                        width: 100%;
                        height: 769px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        display: flex;
                        justify-content: center;
                        padding-top: 10px;
                        .btns_pay{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 36px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                        }
                    }
                   
                   
                   
                }
            }
        }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .case_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .case_detial.no-trans .case_detial_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .case_detial.no-trans .case_detial_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 {
        padding: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 24px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .title_flex img {
        margin-left: 10px;
        width: 70px;
        height: 25px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex .tege_title {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex .tege_text {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .borders {
        height: 15px;
        margin: 0 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns1 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns1 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns2 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 16px;
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns2 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box {
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex .const_title {
        width: 100px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex .const_text {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_const {
        font-size: 14px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_img {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_img img {
        width: 16px;
        height: 14px;
        margin-right: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_name {
        margin-left: 16px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 16px 16px 16px 16px;
        margin-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos .case_titles {
        font-size: 24px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos .case_texts {
        font-size: 14px;
        line-height: 30px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_num_box {
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 16px;
        margin-top: 16px;
        min-height: 44px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos {
        padding: 16px 16px 16px 16px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .user_img {
        width: 64px;
        height: 64px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .user_img img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .user_info {
        padding-left: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .user_info .user_name {
        font-size: 24px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .user_info .user_time {
        padding-top: 11px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_titles {
        font-size: 16px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_consts {
        font-size: 14px;
        padding-top: 15px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section {
        padding: 16px 16px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .titles {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns1 {
        padding: 8px 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns1 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns2 {
        width: 36px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 8px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns2 img {
        width: 14px;
        height: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns3 {
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns3 img {
        width: 13px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list {
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 3px 3px 3px 3px;
        margin-bottom: 16px;
        padding: 16px 16px 16px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_imgs {
        width: 64px;
        height: 64px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_imgs img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding: 8px 0;
        padding-left: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info .names {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info .times {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .num_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .num_flex .nums img {
        width: 21px;
        height: 20px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .comment_text {
        font-size: 14px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_bom {
        border-radius: 4px 4px 4px 4px;
        margin-top: 16px;
        padding: 16px 16px 16px 16px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns span {
        font-size: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns2 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns2 span {
        font-size: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 13px 16px 10px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews .review_title {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews .review_text {
        padding-top: 16px;
        font-size: 14px;
        line-height: 30px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        padding: 13px 16px 14px 16px;
        margin-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box .announcement_title {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box .announcement_text {
        padding-top: 16px;
        font-size: 14px;
        line-height: 32px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show {
        min-height: 0;
        height: auto;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_top {
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_bom {
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_bom .btns_pay {
        width: 134px;
        height: 36px;
        border-radius: 4px 4px 4px 4px;
        line-height: 36px;
        font-size: 14px;
    }
}
</style>
